import type {BioIconProps} from './common-types'

function Icon({...attributes}: BioIconProps) {
  return (
    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M11.6406 0L14.3348 8.2918H23.0533L15.9999 13.4164L18.694 21.7082L11.6406 16.5836L4.5872 21.7082L7.28137 13.4164L0.227947 8.2918H8.94646L11.6406 0Z"
        // fill="#FBBF24"
      />
    </svg>
  )
}

export const FeedbackStarSharp = Icon
